

























































































import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import {
  LinkedAccountType,
  LinkedAccountManagementRequest,
} from "@/shared/types";
import { Validator } from "vee-validate";
import { Location } from "vue-router";
import { UserListActionButtonOptions } from "@/admin/types";
import Users from "@/admin/components/shared/Users.vue";
import Button from "@/shared/components/ui/Button.vue";
import { useUtilityStore } from "@/admin/store/utility";

@Component({
  components: {
    Button,
    Users
  }
})

export default class LinkedAccountManagement extends Vue {
  $validator: Validator;

  utilityStore = useUtilityStore();

  @Prop()
  page: number;

  @Prop()
  routeToUserList: (page: number) => Location;

  isLoaded = false;
  showModalForm = false;

  readonly actionButtonOptions: UserListActionButtonOptions = {
    show: true,
    text: "Link Account",
    click: this.showForm
  };
  showForm (user: { email: string, cognitoUsername: string }) {
    this.model.emailAddress = user.email;
    this.model.cognitoUsername = user.cognitoUsername;
    this.showModalForm = true;
  }
  readonly actionOptions = [
    { text: "Checking Account", value: LinkedAccountType.Checking },
    { text: "Savings Account", value: LinkedAccountType.Savings }
  ];
  updateFormInSubmit = false;

  model: LinkedAccountManagementRequest = {
    emailAddress: "",
    accountName: "",
    accountNumber: "",
    bankName: "",
    routingNumber: "",
    accountType: LinkedAccountType.Checking,
    cognitoUsername: ""
  };

  onSubmitChanges (e: Event) {
    e.preventDefault();
    this.$validator.validateAll()
      .then(isValid => {
        if (this.updateFormInSubmit || !isValid) {
          return;
        }
        this.updateFormInSubmit = true;
        this.doUpdateLinkedAccount();
      });
  }

  onResetForm (e: Event) {
    this.model.accountName = "";
    this.model.accountNumber = "";
    this.model.accountType = LinkedAccountType.Checking;
    this.model.routingNumber = "";
  }

  doUpdateLinkedAccount () {
    this.utilityStore.updateLinkedBankAccount(this.model)
      .then(() => {
        this.updateFormInSubmit = false;
      });
  }
  onClose () {
    this.showModalForm = false;
    this.model.emailAddress = "";
    this.model.cognitoUsername = "";
  }
}

